package ru.villawonka.app.presentation.sharedviews

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.painterResource
import ru.villawonka.app.domain.model.NetworkFailure
import ru.villawonka.app.presentation.design.components.AppButton
import ru.villawonka.app.presentation.design.components.AppButtonSize
import ru.villawonka.app.presentation.design.components.AppButtonType
import ru.villawonka.app.presentation.design.extensions.AppSpacer
import ru.villawonka.app.presentation.design.theme.AppTextStyles
import ru.villawonka.app.presentation.design.theme.onSurfaceSecondary
import ru.villawonka.app.presentation.design.theme.surfaceLow
import ru.villawonka.app.resources.AppResources
import villawonka.composeapp.generated.resources.Res
import villawonka.composeapp.generated.resources.stub_error
import villawonka.composeapp.generated.resources.stub_no_connection
import villawonka.composeapp.generated.resources.stub_no_favorites

@Composable
fun DefaultErrorStateLayout(
    topPadding: Dp = 16.dp,
    failure: NetworkFailure,
    onRetryClick: () -> Unit,
) {
    val needRetryButton = failure !is NetworkFailure.NotFound
    val errorText = when (failure) {
        is NetworkFailure.NoConnection -> AppResources.strings.stubNoConnection
        is NetworkFailure.NotFound -> AppResources.strings.stubNotFound
        is NetworkFailure.HttpError,
        is NetworkFailure.Unauthorized -> AppResources.strings.stubHttpError
    }
    val errorDrawable = when (failure) {
        is NetworkFailure.NoConnection -> Res.drawable.stub_no_connection
        is NetworkFailure.NotFound -> Res.drawable.stub_no_favorites
        is NetworkFailure.HttpError,
        is NetworkFailure.Unauthorized -> Res.drawable.stub_error
    }

    Box(
        modifier = Modifier
            .background(MaterialTheme.colors.surfaceLow)
            .fillMaxSize()
    ) {
        Column(
            modifier = Modifier
                .align(Alignment.Center)
                .padding(
                    top = topPadding,
                    start = 16.dp,
                    end = 16.dp,
                    bottom = 16.dp
                )
            ,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Image(
                painter = painterResource(errorDrawable),
                contentDescription = null
            )
            AppSpacer(8.dp)
            Text(
                text = errorText,
                style = AppTextStyles.bodyMediumMedium,
                color = MaterialTheme.colors.onSurfaceSecondary,
                textAlign = TextAlign.Center,
                modifier = Modifier.padding(horizontal = 27.dp)
            )
            if (needRetryButton) {
                AppSpacer(16.dp)
                AppButton(
                    modifier = Modifier.align(Alignment.CenterHorizontally),
                    text = AppResources.strings.stubRetryButton,
                    size = AppButtonSize.MEDIUM,
                    type = AppButtonType.SECONDARY,
                    onClick = onRetryClick
                )
            }
        }
    }
}